module.exports = __webpack_public_path__ + "img/default.536ddcbc.jpg";